import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';

export enum PortfolioRiskNameDTO {
  LessRisk = 'Less Risk',
  Recommended = 'Recommended',
  MoreRisk = 'More Risk',
}

export interface AssetAllocationDTO {
  name: string;
  y: number;
  color_group: number;
  color: string;
}

export interface EstimatedPerformanceDTO {
  categories: string[];
  series: {
    color: string;
    data: number[];
    label: string;
  }[];
}

export interface PortfolioDTO {
  portfolioId: string;
  groupId: string;
  portfolioName: string;
  assetAllocation: AssetAllocationDTO[];
  estimatedValue: number;
  riskScore: number | null;
  name: string;
  estimatedValueYear: number;
  estimatedPerformance: EstimatedPerformanceDTO;
}

const fetchAutomatedAccountsResults = async (clientId: string): Promise<PortfolioDTO[]> =>
  authFetch(
    urlWithParams('/Consumer/AutomatedAccounts/GetWorkflowResults', {
      clientId,
    }),
  );

export const useGetWorkflowResultsQuery = () => {
  const { clientId } = useRouteParams();

  return useQuery(
    queryKeys.automatedAccountsResults(clientId),
    () => fetchAutomatedAccountsResults(clientId),
    {
      cacheTime: 0,
    },
  );
};
